<template>
  <el-config-provider :locale="locale">
    <router-view />
  </el-config-provider>
  <!-- <router-view /> -->
</template>
<script>

import { ElConfigProvider } from 'element-plus'

// 中文包
import zhCn from 'element-plus/lib/locale/lang/zh-cn'

export default {
  components: {
    [ElConfigProvider.name]: ElConfigProvider
  },
  setup () {
    // 刷新页面
    const fn = () => {
      location.reload()
    }
    console.log(fn)
    // 切换为中文
    let locale = zhCn
    return {
      locale
    }
  },
  // created () {
  //  if( JSON.parse(localStorage.getItem("Menu"))!=null)
  //      this.$store.commit("setMenu", JSON.parse(localStorage.getItem("Menu")) );
  // },
  name: "App",
  data () {
    return {
      isRouterAlive: true,
    };
  },
  provide () {
    return {
      reload: this.reload,
    };
  },
  methods: {
    reload () {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
  },
};
</script>
<style>

/* 取消input的上下箭头 */
input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}
 
input::-webkit-outer-spin-button {
  -webkit-appearance: none !important;
}
 
input[type="number"] {
  -moz-appearance: textfield;
}

::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 6px;
  height: 6px;
}
::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.1);
  border-radius: 0;
}
::-webkit-scrollbar-thumb {
  cursor: pointer;
  border-radius: 5px;
  background: rgba(0, 0, 0, 0.15);
  transition: color 0.2s ease;
}
::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.3);
}
 
@import "./assets/css/main.css";
@import "./assets/css/color-dark.css";
</style>
